import { render, staticRenderFns } from "./CalendarTransportModal.vue?vue&type=template&id=5d10f1a9&scoped=true"
import script from "./CalendarTransportModal.vue?vue&type=script&lang=js"
export * from "./CalendarTransportModal.vue?vue&type=script&lang=js"
import style0 from "./CalendarTransportModal.vue?vue&type=style&index=0&id=5d10f1a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10f1a9",
  null
  
)

export default component.exports